export default __webpack_public_path__ + "static/media/external-link.9cb78e41.svg";